export default "/images/watch.svg?129e41efd720742f7b09236d79496c60";